import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import NotificationListenerWrapper from '@/providers/notification-listener-wrapper'
import { Toaster } from '@/components/ui/toaster'
import GeneralError from '@/pages/errors/general-error'
import NotFoundError from '@/pages/errors/not-found-error'

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  component: () => {
    return (
      <>
        <NotificationListenerWrapper>
          <Outlet />
        </NotificationListenerWrapper>
        <Toaster />
        {import.meta.env.MODE === 'development' && (
          <>
            {/* <ReactQueryDevtools buttonPosition='bottom-right' /> */}
            {/* <TanStackRouterDevtools position='bottom-right' /> */}
          </>
        )}
      </>
    )
  },
  notFoundComponent:
    import.meta.env.MODE === 'production' ? NotFoundError : undefined,
  errorComponent:
    import.meta.env.MODE === 'production' ? GeneralError : undefined,
})
